// The settings this deployment runs with. /config.js, rendered by nginx from the
// container's environment, sets window.EYESON_CONFIG; a key it sets wins over the
// value compiled in from .env, even when empty, so one image serves every tier.
// Without /config.js (a build served some other way) the compiled values apply.
const runtime = (typeof window !== 'undefined' && window.EYESON_CONFIG) || {};

const runtimeEnv = { ...process.env, ...runtime };

// The quick test this deployment links to. Nullish, not falsy: an empty value
// from /config.js means no quick test, never the production one.
export const quicktestUrl =
  runtimeEnv.REACT_APP_QUICKTEST_URL ?? 'https://app.eyeson.team/quicktest/';

export default runtimeEnv;
